import request from '@/utils/request'



// 获取充值信息 
export function getSupperRechargeList(pageNum) {
    return request({
    url: '/api/recharge/supper/officialList',
    method: 'get',
    params: {
      pageNum
    }
  })
}

// 获取充值信息 
export function getSupperWithdrawList(pageNum) {
  return request({
  url: '/api/withdrawal/supper/officialList',
  method: 'get',
  params: {
    pageNum
  }
})
}

// 获取账户信息
export function getSupperAccountInfo(){
  return request({
    url: '/api/account/officialSupper',
    method: 'get'
  })
}

// 审核充值记录
export function rechargeExamine(id,data) {
  return request({
    url: '/api/recharge/examine/'+id,
    method: 'post',
    data: data
  })
}

// 审核充值记录
export function withdrawExamine(id,data) {
  return request({
    url: '/api/withdrawal/examine/'+id,
    method: 'post',
    data: data
  })
}

